import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../shared/state/appContext'
import globalStyles from '../../../../shared/styles/GlobalStyles.module.scss'
import { trackAppointmentBookingTriageSelection } from '../../../../shared/utils/tracking/tracking'
import { PreviousAppointmentFlow } from '../../pageFlowData'
import { triageData } from './data'
import styles from './Triage.module.scss'

export const Triage: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    cars: { triage },
  } = state

  const handleTracking = (id: string, index: number) => {
    trackAppointmentBookingTriageSelection({ id, index })
  }

  const handleDispatch = (id: string) => {
    dispatch({ type: 'UPDATE_TRIAGE_TYPE', data: id })
    dispatch({ type: 'UPDATE_STEP', data: PreviousAppointmentFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: PreviousAppointmentFlow.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string, index: number) => {
    handleTracking(id, index)
    handleDispatch(id)
  }

  const { buttons, imgObj, title } = triageData

  return (
    <div className={globalStyles.fullWidthButton}>
      <PillButtonPage
        buttons={buttons}
        defaultValue={triage ? triage : ''}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        infoBoxData={triageData}
        pillButtonGroupStyle={styles.triagePillButtons}
        title={title}
      />
    </div>
  )
}
